<template>
  <v-app>
    <!-- <data-tracker>>
      <Vuex Store: {{ $store.state.Profile.locationInfo.timeZone.info.gmt }}
      </data-tracker-->
    <main-drawer></main-drawer>
    <base-sidesheet></base-sidesheet>
    <base-snackbar></base-snackbar>
    <main-header></main-header>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  components: {
    "main-header": require("./components/mainHeader/mainHeader").default,
    "main-drawer": require("./components/mainDrawer/mainDrawer").default,
    "base-sidesheet": require("./components/common/baseSidesheet").default,
  },
  mounted(){
    this.$store.dispatch('Common/fetchMarquee')
    this.$store.dispatch('Profile/fetchPreferredLanguage')
  }
};
</script>

<style lang="sass">
@import url('https://fonts.googleapis.com/css2?family=Libre+Franklin:wght@100;200;300;400;500;600;700;900&display=swap')
#app
  min-width: 20rem

.v-main__wrap
  padding: 0 24px // Main content left and right padding (move the property to inner element if necessary)
</style>
